"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = mapOrder;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _mapProductOrder = _interopRequireDefault(require("../mapProductOrder"));
var _imagesNew = require("@deosite/mock-data/images-new");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function mapOrder(order, productsForImage) {
  var _order$payment, _order$payment$additi;
  var billingAddress = order.billingAddress,
    shippingAddress = order.shippingAddress,
    shipments = order.shipments;
  var products = order.products;
  products = products.map(function (product) {
    var _productsForImage$fil;
    var productImage = productsForImage === null || productsForImage === void 0 ? void 0 : (_productsForImage$fil = productsForImage.filter(function (productImage) {
      return productImage.sku === product.sku;
    })) === null || _productsForImage$fil === void 0 ? void 0 : _productsForImage$fil[0];
    return (0, _mapProductOrder["default"])(_objectSpread(_objectSpread({}, product), {}, {
      image: productImage !== null && productImage !== void 0 && productImage.image ? productImage === null || productImage === void 0 ? void 0 : productImage.image : _imagesNew.no_image,
      url: productImage === null || productImage === void 0 ? void 0 : productImage.url
    }));
  });
  var tracks = shipments === null || shipments === void 0 ? void 0 : shipments[0].tracks.map(function (track) {
    return {
      trackNumber: track.track_number,
      courierName: track.title
    };
  });
  return {
    id: order.increment_id,
    totalPrice: order.base_grand_total,
    status: order.status,
    isPaymentPaid: order.payment.amount_ordered === order.payment.amount_paid,
    methodPayment: order.payment.method,
    paymentType: (_order$payment = order.payment) === null || _order$payment === void 0 ? void 0 : (_order$payment$additi = _order$payment.additional_information) === null || _order$payment$additi === void 0 ? void 0 : _order$payment$additi[0],
    billingAddress: billingAddress,
    shippingAddress: shippingAddress,
    skus: order.skus,
    tracks: tracks,
    creationDate: order.created_at,
    updateDate: order.updated_at,
    shippingPrice: order.shipping_incl_tax,
    tax: order.base_tax_amount,
    discount: order.base_discount_amount,
    subtotal: order.base_subtotal_incl_tax,
    products: products,
    ePoints: order.extension_attributes.rewardpoints_earn ? {
      ePointsEarned: order.extension_attributes.rewardpoints_earn,
      ePointsSpent: order.extension_attributes.rewardpoints_spent,
      priceDiscount: order.extension_attributes.rewardpoints_discount
    } : {}
  };
}